const ExtradeportivoIcon = ({ iconWidth = 16, iconHeight = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={iconWidth} height={iconHeight} viewBox="0 0 24 24">
            <g fill="none">
                <path
                    fill="url(#IconifyId196ed8433ec29af72)"
                    d="M10.03 3.659c.856-1.548 3.081-1.548 3.937 0l7.746 14.001c.83 1.5-.255 3.34-1.969 3.34H4.254c-1.715 0-2.8-1.84-1.97-3.34z"
                />
                <path
                    fill="url(#IconifyId196ed8433ec29af73)"
                    d="M12.997 17A.999.999 0 1 0 11 17a.999.999 0 0 0 1.997 0m-.259-7.852a.75.75 0 0 0-1.493.103l.004 4.501l.007.102a.75.75 0 0 0 1.493-.103l-.004-4.502z"
                />
                <defs>
                    <linearGradient
                        id="IconifyId196ed8433ec29af72"
                        x1="5.125"
                        x2="16.719"
                        y1="-.393"
                        y2="23.477"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFCD0F" />
                        <stop offset="1" stopColor="#FE8401" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId196ed8433ec29af73"
                        x1="9.336"
                        x2="13.752"
                        y1="8.5"
                        y2="18.405"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#4A4A4A" />
                        <stop offset="1" stopColor="#212121" />
                    </linearGradient>
                </defs>
            </g>
        </svg>
    );
};

export default ExtradeportivoIcon;
